import { useEffect, useState } from "react";
import { PublicLayout } from "@/components/Layout";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";

export default function Beneficios() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("");
  useEffect(()=>{ api.get("/benefits").then(r=>setItems(r.data)); }, []);

  const cats = [...new Set(items.map(b=>b.category))];
  const filtered = items.filter(b =>
    (!cat || b.category===cat) &&
    (!q || (b.title+b.partner_name+b.description).toLowerCase().includes(q.toLowerCase())));

  return (
    <PublicLayout>
      <section className="gs-warm-bg py-14">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-xs uppercase tracking-widest text-[#FF7D54] font-semibold">Vantagens da rede</div>
          <h1 className="text-3xl sm:text-4xl font-extrabold" style={{fontFamily:"Plus Jakarta Sans"}}>Benefícios GIRO+SAÚDE</h1>
          <p className="mt-3 text-slate-600 max-w-2xl">Descontos e vantagens em consultas, exames, farmácias e bem-estar em toda a Baixada Santista.</p>
          <div className="mt-6 flex flex-wrap gap-2">
            <Input data-testid="beneficios-q" value={q} onChange={e=>setQ(e.target.value)} placeholder="Buscar benefício..." className="max-w-xs bg-white"/>
            <select data-testid="beneficios-cat" value={cat} onChange={e=>setCat(e.target.value)} className="h-10 rounded-md border border-input px-3 text-sm bg-white">
              <option value="">Todas categorias</option>
              {cats.map(c=><option key={c} value={c}>{c}</option>)}
            </select>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-10">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map(b=>(
            <Card key={b.id} className="overflow-hidden border-slate-200 gs-shadow" data-testid={`beneficio-${b.id}`}>
              {b.image_url && <img src={b.image_url} alt={b.title} className="h-40 w-full object-cover"/>}
              <div className="p-5">
                <div className="flex items-center justify-between">
                  <Badge className="bg-[#E6F4F1] text-[#0D7C66] border-0">{b.category}</Badge>
                  <span className="text-xs text-slate-500">{b.city}</span>
                </div>
                <div className="font-semibold text-lg mt-2">{b.title}</div>
                <div className="text-sm text-slate-600 mt-1">{b.description}</div>
                <div className="mt-4 pt-4 border-t border-slate-100 text-xs text-slate-500">
                  <div>Parceiro: <b className="text-slate-800">{b.partner_name}</b></div>
                  {b.condition && <div>Condição: {b.condition}</div>}
                  {b.validity && <div>Validade: {b.validity}</div>}
                </div>
              </div>
            </Card>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
